import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { Injectable } from '@angular/core';
import { ExportSettingsResponseDto } from '@whetstoneeducation/hero-common';
import { AppExportService } from '../export.service';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppExportSettingsResolver extends BaseResolver<ExportSettingsResponseDto> {
  constructor(
    private readonly exportService: AppExportService,
    resolverErrorHandler: AppResolverErrorHandlerService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<ExportSettingsResponseDto> {
    const id = route.paramMap.get('id');
    if (id === 'new') {
      return new ExportSettingsResponseDto();
    } else {
      return await this.exportService.getExportSettings(parseInt(id));
    }
  }
}
